/**
 * Update Toast
 * Notifies the user when a new version of Bubakii OS has been installed in
 * the background so they can refresh on their own terms instead of losing
 * in-progress work to a surprise reload.
 */
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useAppUpdate } from "../hooks/useAppUpdate";

/** UX timing for the informational offline-ready toast only — not a business setting. */
const OFFLINE_READY_AUTO_HIDE_MS = 6000;

function UpdateToast() {
  const { needRefresh, offlineReady, dismiss, refresh } = useAppUpdate();

  return (
    <Snackbar
      open={needRefresh || offlineReady}
      autoHideDuration={needRefresh ? null : OFFLINE_READY_AUTO_HIDE_MS}
      onClose={(_event, reason) => {
        if (reason === "clickaway" || needRefresh) {
          return;
        }
        dismiss();
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        severity="info"
        variant="filled"
        action={
          <>
            {needRefresh && (
              <Button color="inherit" size="small" onClick={refresh}>
                Refresh
              </Button>
            )}
            <IconButton
              aria-label="Dismiss"
              color="inherit"
              size="small"
              onClick={dismiss}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      >
        {needRefresh
          ? "A new version is available. Refresh to update."
          : "Bubakii OS is ready to work offline."}
      </Alert>
    </Snackbar>
  );
}

export default UpdateToast;
